import React from "react"

const MainWrapper = props => {
  return <main className="lg:w-[750px]">{props.children}</main>
}

export default MainWrapper
